import { references, SchemesGenerator } from '../../ui/form/components/Application/schemes';
import gettable21 from './gettable2.1';
import gettable3 from "./gettable2.2";
import gettable4 from "./gettable2.3";
import gettable5 from "./gettable2.4";

export default function ApplicationFormProcess(state, flag1=false, flag2=false) {
  let dataValue;
  console.log(flag1);
  console.log(flag2);
  if(flag1) {
    dataValue = state.objects.applicationformdata.value;
  }
  else if (flag2) {
    dataValue = {
      "tbl-1-1": tbl11,
      "tbl-1-2": tbl12,
      "tbl-1-3": tbl13,
      "tbl-1-4": tbl14,
      "tbl-1-5": tbl15,
      "tbl-2-1": gettable21(state),
      "tbl-2-2-1": gettable3(state),
      "tbl-2-2-2": gettable4(state),
      "tbl-2-2-3": gettable5(state),
      "tbl-2-4-1": tbl241,
      "tbl-2-4-2": tbl242,
      "tbl-5-1": tbl51,
      "tbl-5-2": tbl52,
      "tbl-5-3": tbl53
    };
  }
  else {
    dataValue = {
      "tbl-2-1": gettable21(state),
      "tbl-2-2-1": gettable3(state),
      "tbl-2-2-2": gettable4(state),
      "tbl-2-2-3": gettable5(state)
    };
  }

  return {
    type: "ReadValue",
    subj: "Заявитель",
    objName: ["applicationformdata"],
    form: {
      type: "SumForm",
      caption: "Открыть меню заполнения таблиц заявки",
      subforms: [
        getApplicationForm({ readOnly: false, state, dataValue }),
      ],
    },
  };
}

export function getApplicationForm({ readOnly, state, dataValue }) {
  return {
    type: "ApplicationForm",
    references,
    readOnly,
    schemas: SchemesGenerator.application(+state.objects.year),
    datas: dataValue,
  };
}

const tbl11 = [
  ['', 'Цемент ЦЕМ I 42,5H', '23.51.12.111', 'тонн', 554636, 520492, 520492, 520492, 520492, 520492, 520492, 520492],
  ['', 'Цемент ЦЕМ II/A-Ш 32,5H СС', '23.51.12.112', 'тонн', 8394, 8394, 8394, 8394, 8394, 8394, 8394, 8394]
];

const tbl12 = [
  ['', 'Известняк', '08.11.20.110', 'тонн', 790356, 803120, 803120, 803120, 803120, 803120, 803120, 803120],
  ['', 'Глина', '08.12.22.110', 'тонн', 130784, 132403, 128934, 128092, 127620, 127801, 127373, 128016]
]

const tbl13 = [
  ['', '984,7', '359,4', 'Артезианские скважины', '359,4', '359,4', '359,4', '359,4', '359,4', '359,4', '359,4']
]

const tbl14 = [
  ['', 'тыс кВт/ч', '90176', '88780', '86190', '86190', '86190', '86190', '86190', '86190']
]

const tbl15 = [
  ['', 'Природный газ', 'Гкал', '83240', '83240', '83240', '83240', '83240', '83240', '83240', '83240']
]

const tbl242T = 'Технологические показатели физических воздействий в ИТС-6 «Производство цемента» и в приказе Минприроды России от 02.04.2019 №210 Об утверждении нормативного документа в области охраны окружающей среды «Технологические показатели наилучших доступных технологий производства цемента» не установлены'

const tbl241 = [
  ['', 'Ковшовый элеватор гомогенизации сырьевой муки', '1', 'Шумовое воздействие'],
  ['', 'Ковшовый элеватор дозирования сырьевой муки в печь', '1', 'Шумовое воздействие'],
  ['', 'Вентилятор теплообменника', '2', 'Шумовое воздействие'],
  ['', 'Вентилятор отходящих газов клинкерного холодильника (ПЛ-1)', '1', 'Шумовое воздействие']
]

const tbl242 = [
  ['', 'Ковшовый элеватор гомогенизации сырьевой муки', 'Шумовое воздействие', tbl242T, tbl242T],
  ['', 'Ковшовый элеватор дозирования сырьевой муки в печь', 'Шумовое воздействие', tbl242T, tbl242T],
  ['', 'Вентилятор теплообменника', 'Шумовое воздействие', tbl242T, tbl242T],
  ['', 'Вентилятор отходящих газов клинкерного холодильника (ПЛ-1)', 'Шумовое воздействие', tbl242T, tbl242T]
]

const tbl51 = [
  ['', 'Отходы минеральных масел гидравлических, не содержащих галогены', '40612001313', '3', 'Техническое обслуживание оборудования и специальной техники', '-', '-', '1,300'],
  ['', 'Обтирочный материал, загрязненный нефтью или нефтепродуктами (содержание нефти или нефтепродуктов менее 15 %)', '91920402604', '4', 'Обслуживание машин и оборудования', '0,095', '12', '1,140'],
  ['', 'Тара из черных металлов, загрязненная лакокрасочными материалами (содержание менее 5%)', 46811202514, 4, 'Покрасочные работы', '-', '-', '0,147'],
  ['', 'Каски защитные пластмассовые, утратившие потребительские свойства', 49110101525, 5, 'Носка защитных касок', '-', '-', '0,049']
  
]

const tbl52 = [
  [
    1,
    "Каски защитные пластмассовые, утратившие потребительские свойства",
    "49110101525",
    "Открытая площадка с грунтовым покрытием для захоронения твердых бытовых отходов",
    "56-00019-З-00164-27022015",
    "0,343",
    "0,049",
    "0,049",
    "0,049",
    "0,049",
    "0,049",
    "0,049",
    "0,049"
  ]
]

const tbl53 = [
  ['', 'Отходы минеральных масел гидравлических, не содержащих галогены', 40612001313, 'тонн', '1,300', '1,300', '', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-'],
  ['', 'Обтирочный материал, загрязненный нефтью или нефтепродуктами (содержание нефти или нефтепродуктов менее 15 %)', 91920402604, 'тонн', '1,140', '1,140', '', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-'],
  ['', 'Тара из черных металлов, загрязненная лакокрасочными материалами (содержание менее 5%)', 46811202514, 'тонн', '0,147', '0,147', '', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-'],
  ['', 'Каски защитные пластмассовые, утратившие потребительские свойства', 49110101525, 'тонн', '0,049', '0,049', '', 'Открытая площадка с грунтовым покрытием для захоронения твердых бытовых отходов', '56-00019-З-00164-27022015', '0,343', '0,049', '0,049', '0,049', '0,049', '0,049', '0,049', '0,049', '', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-']
]

